import React, { useEffect } from 'react';

import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useGetInterestQuery } from '../../../../../../redux/services/fj_interests';
import { Spinner } from '../../../../../common/index.jsx';
import FjInterestForm from './FjInterestForm.jsx';
import CollapseBlock from '../../../../../common/blocks/CollapseBlock/CollapseBlock.jsx';
import { useTranslation } from 'react-i18next';
import { AppBarCMS } from '../../../../../basic/index.jsx';
import { useSelector } from 'react-redux';
import { useGetFjJobQuery } from '../../../../../../redux/services/fj_jobs';
import { routes } from '../../../../../../utils/helpers/ApiClient.jsx';

const FjInterestsEdit = ({ mode }) => {
  const user = useSelector((state) => state.auth.user);
  const { t } = useTranslation();
  const { id } = useParams();
  const { data: interest, isLoading: isLoadingInterest } = useGetInterestQuery(
    id,
    {
      skip: mode === 'create',
    },
  );
  const { data: job, isLoading: isLoadingJob } = useGetFjJobQuery(id, {
    skip: mode === 'edit',
  });

  // Create pageTitle constant
  const pageTitle =
    t(`Záujem o pracovnú ponuku ${mode === 'create' ? job?.title : interest?.job?.title}
    (${mode === 'create' ? job?.external_partner?.name : interest?.job?.external_partner?.name})`);

  // Set document title
  useEffect(() => {
    if (pageTitle) {
      document.title = `${pageTitle} - FRI.jobs`;
    }
  }, [pageTitle]);

  const valuesForCreate = {
    mail: user?.mail,
  };

  const initials = {
    ...interest,
  };

  return isLoadingInterest || isLoadingJob ? (
    <Spinner />
  ) : (
    <>
      <AppBarCMS
        title={pageTitle}
        backUrl={routes.cmsFriJobsMyInterests}
        backUrlTooltip={t('Späť')}
      />
      <div style={{ margin: '10px' }}>
        <CollapseBlock title={t('Informácie o mne')}>
          <FjInterestForm
            initialValues={mode === 'create' ? valuesForCreate : initials}
            id={mode === 'create' ? null : interest.id}
            fj_job_id={mode === 'edit' ? null : job.id}
            mode={mode}
            resumeObject={interest?.resume_object
              ?.split('-')
              .slice(1)
              .join('-')}
            motivationLetterObject={interest?.motiv_letter_object
              ?.split('-')
              .slice(1)
              .join('-')}
          />
        </CollapseBlock>
      </div>
    </>
  );
};

FjInterestsEdit.propTypes = {
  mode: PropTypes.string,
};

export default FjInterestsEdit;
